"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The default mime model implementation.
 */
var MimeModel = /** @class */ (function () {
    /**
     * Construct a new mime model.
     */
    function MimeModel(options) {
        if (options === void 0) { options = {}; }
        this.trusted = !!options.trusted;
        this._data = options.data || {};
        this._metadata = options.metadata || {};
        this._callback = options.callback || Private.noOp;
    }
    Object.defineProperty(MimeModel.prototype, "data", {
        /**
         * The data associated with the model.
         */
        get: function () {
            return this._data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MimeModel.prototype, "metadata", {
        /**
         * The metadata associated with the model.
         */
        get: function () {
            return this._metadata;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set the data associated with the model.
     *
     * #### Notes
     * Depending on the implementation of the mime model,
     * this call may or may not have deferred effects,
     */
    MimeModel.prototype.setData = function (options) {
        this._data = options.data || this._data;
        this._metadata = options.metadata || this._metadata;
        this._callback(options);
    };
    return MimeModel;
}());
exports.MimeModel = MimeModel;
/**
 * The namespace for module private data.
 */
var Private;
(function (Private) {
    /**
     * A no-op callback function.
     */
    function noOp() { }
    Private.noOp = noOp;
})(Private || (Private = {}));
